import React, { useEffect } from "react";

interface FirstLoginModalProps {
  onClose: () => void;
  onShow?: () => void;
}

const FirstLoginModal: React.FC<FirstLoginModalProps> = ({
  onClose,
  onShow,
}) => {
  useEffect(() => {
    // Call onShow when the modal is rendered
    if (onShow) {
      onShow();
    }
  }, [onShow]);

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white dark:bg-gray-800 rounded-lg shadow-xl"
        style={{ width: "500px", height: "400px" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="h-full flex flex-col items-center justify-center p-8">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6 text-center">
            Welcome to Cobutler!
          </h2>
          <p className="text-gray-700 dark:text-gray-300 mb-8 text-center leading-relaxed">
            We're already setting up your account in the background - adding
            labels to your inbox and syncing past messages to build your initial
            filtering rules. You can explore the dashboard more, or you can just
            sit back and let us keep your inbox focused!
          </p>
          <button
            onClick={onClose}
            className="px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Let's go!
          </button>
        </div>
      </div>
    </div>
  );
};

export default FirstLoginModal;
